module.exports = __webpack_public_path__ + "img/Stefan.098721ee.jpg";